export default "__VITE_ASSET__MgZeHGv$__"